import { render, staticRenderFns } from "./divvy-setting-list.vue?vue&type=template&id=03638792&scoped=true&"
import script from "./divvy-setting-list.vue?vue&type=script&lang=js&"
export * from "./divvy-setting-list.vue?vue&type=script&lang=js&"
import style0 from "./divvy-setting-list.vue?vue&type=style&index=0&id=03638792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03638792",
  null
  
)

export default component.exports